import { ContentBlocks } from "eddev/blocks"
import { defineView } from "eddev/views"

export default defineView("single-events", (props) => {
  return <ContentBlocks className="text-wrap" blocks={props.event?.contentBlocks} />
})
